/**
 * Collection filter sidebar toggle (default collection template only).
 *
 * Opens/closes the vertical facet sidebar on desktop & tablet (>=750px):
 *   - Clicking the "Filter" label opens it; clicking the close (X) closes it.
 *   - Closed (default) -> sidebar hidden, product grid shows 4 per row.
 *   - Open             -> sidebar visible, product grid shows 3 per row.
 *
 * State is kept on the <html> element (class) so it survives the section
 * re-render that applying a facet triggers, and is mirrored to sessionStorage
 * so it persists across page loads. The matching layout rules live in
 * blocks/filters.liquid, scoped to .collection-wrapper--filter-toggle.
 */
(function () {
  var KEY = 'asiatic:collection-filters-open';
  var OPEN_CLASS = 'collection-filters--open';
  var root = document.documentElement;

  function isOpen() {
    return root.classList.contains(OPEN_CLASS);
  }

  function syncAria() {
    var open = isOpen();
    document.querySelectorAll('[data-collection-filter-open]').forEach(function (el) {
      el.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function setOpen(open) {
    root.classList.toggle(OPEN_CLASS, open);
    try {
      sessionStorage.setItem(KEY, open ? '1' : '0');
    } catch (e) {
      /* sessionStorage may be unavailable (private mode) */
    }
    syncAria();
  }

  function restore() {
    var stored = null;
    try {
      stored = sessionStorage.getItem(KEY);
    } catch (e) {
      /* ignore */
    }
    // Default state is closed.
    setOpen(stored === '1');
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-collection-filter-open]');
    if (opener) {
      event.preventDefault();
      setOpen(!isOpen());
      return;
    }

    var closer = event.target.closest('[data-collection-filter-close]');
    if (closer) {
      event.preventDefault();
      setOpen(false);
    }
  });

  // Keyboard support for the Filter label (it is a role="button", not a <button>).
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    var opener = event.target.closest && event.target.closest('[data-collection-filter-open]');
    if (!opener) return;
    event.preventDefault();
    setOpen(!isOpen());
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restore);
  } else {
    restore();
  }

  // Keep aria state correct after the theme editor re-renders the section.
  document.addEventListener('shopify:section:load', syncAria);
})();
